import React from "react";
import styled from "styled-components";

import ActivityPage from "../activity/ActivityPage";
import StockPage from "../stocks/StockPage";
import AuthorPage from "../author/AuthorPage";
import {Route, Switch} from "react-router-dom";
import Nav from "./navigation/Nav";
import OurProgrammePage from "../ourprogramme/OurProgrammePage";
import PortfolioExplorePage from "../ourprogramme/explore/PortfolioExplorePage";
import NotFoundPage from "./NotFoundPage";
import CompanyWithinPortfolioExplorePage from "../ourprogramme/company/CompanyWithinPortfolioExplorePage";
import PortfolioPage from "../ourprogramme/portfolio/PortfolioPage";
import CompanyWithinPortfolioPage from "../ourprogramme/company/CompanyWithinPortfolioPage";
import NotificationsArea from "../notification/NotificationsArea";
import CreateIdeaModal from "../contribute/createIdea/CreateIdeaScreenModal";
import Homepage from "./Homepage";
import AuthorHomepage from "../contribute/homepage/AuthorHomepage";
import PortfolioAuthor from "../contribute/portfolioauthor/PortfolioAuthor";
import AppHeader from "./header/AppHeader";
import SystemBroadcastMessage from "./SystemBroadcastMessage";
import HelpVideos from "../help/HelpVideos";

const AppContainer = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
`;

const App = ({}) =>
    <AppContainer>
        <AppHeader/>
        <SystemBroadcastMessage />
        <Nav/>
        <Switch>
            <Route exact path="/">
                <Homepage/>
            </Route>
            <Route exact path="/stock/:orgId/idea/:ideaId">
                <StockPage/>
            </Route>
            <Route path="/stock/:orgId">
                <StockPage/>
            </Route>
            <Route path="/author/:authorId">
                <AuthorPage/>
            </Route>
            <Route exact path="/contribute">
                <AuthorHomepage/>
            </Route>
            <Route exact path="/contribute/:portfolioId/:authorId">
                <PortfolioAuthor/>
            </Route>
            <Route exact path="/contribute/:portfolioId/:authorId/period/:rewardPeriodBasis/:rewardPeriodStartDate">
                <PortfolioAuthor/>
            </Route>
            <Route path="/stocks">
                <ActivityPage/>
            </Route>
            <Route exact path="/our-programme">
                <OurProgrammePage/>
            </Route>

            <Route exact path="/our-programme/portfolio/:portfolioId">
                <PortfolioPage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/period/:rewardPeriodBasis/:rewardPeriodStartDate">
                <PortfolioPage/>
            </Route>

            <Route exact path="/our-programme/portfolio/:portfolioId/company/:companyId">
                <CompanyWithinPortfolioPage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/company/:companyId/period/:rewardPeriodBasis/:rewardPeriodStartDate">
                <CompanyWithinPortfolioPage/>
            </Route>

            <Route exact path="/our-programme/portfolio/:portfolioId/explore/:firstGroupingName/page/:pageNumber">
                <PortfolioExplorePage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/explore/:firstGroupingName">
                <PortfolioExplorePage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/explore/:firstGroupingName/:secondGroupingName/page/:pageNumber">
                <PortfolioExplorePage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/explore/:firstGroupingName/:secondGroupingName">
                <PortfolioExplorePage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/period/:rewardPeriodBasis/:rewardPeriodStartDate/explore/:firstGroupingName/page/:pageNumber">
                <PortfolioExplorePage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/period/:rewardPeriodBasis/:rewardPeriodStartDate/explore/:firstGroupingName">
                <PortfolioExplorePage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/period/:rewardPeriodBasis/:rewardPeriodStartDate/explore/:firstGroupingName/:secondGroupingName/page/:pageNumber">
                <PortfolioExplorePage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/period/:rewardPeriodBasis/:rewardPeriodStartDate/explore/:firstGroupingName/:secondGroupingName">
                <PortfolioExplorePage/>
            </Route>

            <Route exact path="/our-programme/portfolio/:portfolioId/company/:companyId/explore/:firstGroupingName/page/:pageNumber">
                <CompanyWithinPortfolioExplorePage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/company/:companyId/explore/:firstGroupingName">
                <CompanyWithinPortfolioExplorePage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/company/:companyId/explore/:firstGroupingName/:secondGroupingName/page/:pageNumber">
                <CompanyWithinPortfolioExplorePage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/company/:companyId/explore/:firstGroupingName/:secondGroupingName">
                <CompanyWithinPortfolioExplorePage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/company/:companyId/period/:rewardPeriodBasis/:rewardPeriodStartDate/explore/:firstGroupingName/page/:pageNumber">
                <CompanyWithinPortfolioExplorePage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/company/:companyId/period/:rewardPeriodBasis/:rewardPeriodStartDate/explore/:firstGroupingName">
                <CompanyWithinPortfolioExplorePage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/company/:companyId/period/:rewardPeriodBasis/:rewardPeriodStartDate/explore/:firstGroupingName/:secondGroupingName/page/:pageNumber">
                <CompanyWithinPortfolioExplorePage/>
            </Route>
            <Route exact path="/our-programme/portfolio/:portfolioId/company/:companyId/period/:rewardPeriodBasis/:rewardPeriodStartDate/explore/:firstGroupingName/:secondGroupingName">
                <CompanyWithinPortfolioExplorePage/>
            </Route>

            <Route path="/help">
                <HelpVideos/>
            </Route>

            <Route>
                <NotFoundPage/>
            </Route>
        </Switch>
        <CreateIdeaModal/>
        <NotificationsArea/>
    </AppContainer>;

export default App;
